import React, {Fragment} from 'react';
import cx from 'classnames';
import {connect} from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import UserBox from "./UserBox";
import AppLogo from "../assets/utils/images/logo.png";
import {getOrganizationInfo, getSessionValue} from "../Common/Appcommon";

class Header extends React.Component {
    render(){
        let {
            headerBackgroundColor,
            enableMobileMenuSmall,
            enableHeaderShadow,
            appCustomTitle
        } = this.props;

        const awsS3URL = process.env.REACT_APP_CRATIO_AWS_S3_URL;
        const orgFormName = process.env.REACT_APP_ORGANIZATION_FORMNAME;
        const orgLogo = getOrganizationInfo('logo');
        const organizationId = getOrganizationInfo('organizationid');
        const appid = getSessionValue('appid');
        const appTitle = getSessionValue('appTitle');
        let customerLogo = "";

        if(orgLogo !== undefined && orgLogo !== null && orgLogo !== ""){
            customerLogo = `${awsS3URL}Content/${appid}/${orgFormName}/${organizationId}/${orgLogo}`;
        }

        return (
            <Fragment>
                <TransitionGroup>
                    <CSSTransition
                        component="div"
                        className={cx("app-header", headerBackgroundColor, {'header-shadow': enableHeaderShadow})}
                        appear={true}
                        timeout={1500}
                        enter={false}
                        exit={false}>
                        <div>
                            <div className={cx(
                                "app-header__content",
                                {'header-mobile-open': enableMobileMenuSmall},
                            )}>
                                <div className="app-header-left">
                                    <div className="app-header__logo">
                                        <img src={customerLogo !== "" ? customerLogo : AppLogo} alt={'applogo'} className="logo-src"/>
                                    </div>
                                </div>
                                <div className="app-header-center">
                                    <span>{appTitle}</span>
                                </div>
                                <div className="app-header-right">
                                    <UserBox />
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
